import React, { useEffect, useRef, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { BASE_URL, IMAGE_URL } from '../../../config/axios';
import { formatDate } from '../../Date';
import { CircularGrid, Eye, Filter, Office, DocumentIcon } from '../../AllSvg';
import { AttachmentIcon, CustomImageModal, DateRangePicker, formatCurrencyIndian, FormatKey, formatRoundoff2D, handleErrorToast, ViewDynamicApprovalDates, ViewDynamicApprovalRemarks, ViewDynamicApprovalStatus, ViewFile } from '../../CustomFunctions';
import { DynamicRequestImprestApproval, DynamicRequestImprestEditApproval, DynamicRequestImprestRejection, DynamicRequestImprestFinalize, DynamicRequestExpenseFinalize, InvestmentDeclarationSummary, InvestmentProofSummary, ArrearSummary, ArrearDynamicApprovalActionModal, CompensatoryLeaveSummary } from './DynamicApprovalComponents';
import { useNavigate } from 'react-router-dom';
import usePermission from '../../../config/permissions';
import UserDefaultLogo from '../../UserDetails/UserDefaultLogo';
import Loader from '../../Loader';
import { DynamicApprovalInvestmentDeclarationAction, DynamicApprovalInvestmentProofsAction, BankDetailsDynamicApprovalActionModal, CompensatoryDynamicApprovalActionModal } from './DynamicApprovalComponents';
import { CompoffShortLeaveApproved, CompoffShortLeaveReject } from "../../workforcemanagement/Requestapproved";
// const DynamicLeaveApprovalTable = ({ showdashboard, level, approval_stages }) => {

//     const [buffer, setBuffering] = useState(true); //buffering logic
//     const [buffer1, setBuffering1] = useState(true); //buffering logic
//     const [ImprestList, setImprestList] = useState([]);
//     const [previousStatus, setPreviousStatus] = useState("approved");
//     const [selectedStatus, setSelectedStatus] = useState("pending");
//     const [selectedProject, setProject] = useState("null");
//     const [fromdate, setFromDate] = useState("null");
//     const [todate, setToDate] = useState("null");
//     const [selectedDivision, setDivision] = useState(
//         `${sessionStorage.getItem("company_id") || null}`
//     );
//     const [SubCompany, setSubCompany] = useState([]);

//     const getSubCompany = async () => {
//         setBuffering1(true); //buffering logic // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//             setSubCompany(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering1(false); //buffering logic // End Buffering
//         }
//     };

//     useEffect(() => {
//         getSubCompany();
//     }, [])

//     //! ******************************API start***************************//
//     const getDynamicTenderRequestData = async () => {
//         try {
//             setBuffering(true); //buffering logic // Start Buffering
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/tenderrequestamountdynamicapprovalspreviousfilter/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/`
//             );
//             setImprestList(res.data)
//             console.log(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };

//     useEffect(() => {
//         console.log(level, "tender useefect")
//         if (level != 0) {
//             getDynamicTenderRequestData();
//         }

//     }, [level, selectedStatus])

//     return (
//         <>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             <div className="attendance-history-cont">
//                 <div className="attendance-heading  font-weight500 font-size-heading"> </div>
//                 <div className="attendance-subcont">
//                     <div className="field-cont">
//                         <div className="field-cont-div">
//                             <div title=' Date Range' className="date-uppercase ">
//                                 <DateRangePicker startDate={fromdate} endDate={todate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
//                                     setFromDate(start);
//                                     setToDate(end);
//                                 }} />
//                             </div>
//                             <hr className="field-cont-hr" />
//                         </div>
//                         <div title='All' className="field-cont-div">
//                             <Filter />
//                             <select
//                                 className="attendance-input-field width-10vw   date-field"
//                                 type="text"
//                                 value={selectedStatus}
//                                 // onChange={(e) => setSelectedStatus(e.target.value)}
//                                 onChange={(e) => {
//                                     const value = e.target.value;
//                                     setSelectedStatus(value);
//                                     setPreviousStatus(value === "rejected" ? "pending" : "approved");
//                                 }}
//                                 style={{ cursor: 'pointer' }}
//                             >
//                                 <option value="null">All</option>
//                                 <option value="pending">Pending</option>
//                                 <option value="approved">Approved</option>
//                                 <option value="rejected">Rejected</option>
//                             </select>
//                             <hr className="field-cont-hr" />
//                         </div>
//                         <div title='Sub Companies' className="field-cont-div">
//                             {buffer ? <div className="spinner-vsmall"></div> : <Office />}
//                             <select
//                                 className="attendance-input-field width-10vw date-field"
//                                 type="text"
//                                 value={selectedDivision}
//                                 onChange={(e) => setDivision(e.target.value)}
//                             >
//                                 <option value="null">All Sub Companies</option>
//                                 {SubCompany.sort((a, b) => a.title - b.title).map(
//                                     (i, index) => (
//                                         <option value={i.id}>{i.title}</option>
//                                     )
//                                 )}
//                                 ;
//                             </select>
//                             <hr className="field-cont-hr" />
//                         </div>
//                         <div className="field-cont-div">
//                             <Projects value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
//                         </div>
//                     </div>
//                     <div className="btn-cont"></div>
//                     <div className="">
//                         <div>
//                             {/* <DownloadTenderBill projectList={ImprestList} /> */}
//                         </div>
//                     </div>
//                 </div>

//                 <div className="table-css-white-background scroll-container-table">
//                     <div className="table-heading-flex">
//                         <div className="repo-heading font-weight500 font-size-heading">Stage {level} of Tender</div>
//                     </div>
//                     <table className="table-css">
//                         <thead className="table-heading stciky-heading-top">
//                             <tr className="custom-table-head-tr">
//                                 <th className="table-heading-text text-lefttt">S. No.</th>
//                                 <th className="table-heading-text" style={{ textAlign: "center" }}>Bank Name</th>
//                                 <th className="table-heading-text">Request Type</th>
//                                 <th className="table-heading-text">Amount</th>
//                                 <th className="table-heading-text">Approved Amount</th>
//                                 <th className="table-heading-text" style={{ textAlign: "center" }}>Document</th>
//                                 <th className="table-heading-text">Date</th>
//                                 <th className="table-heading-text">Expiry Date</th>
//                                 <th className="table-heading-text">Release Date</th>

//                                 <th className="table-heading-text">Bid</th>
//                                 <th className="table-heading-text">Remarks</th>
//                                 <th className="table-heading-text">Status</th>
//                                 <th className="table-heading-text text-end">Action</th>
//                             </tr>
//                         </thead>
//                         {buffer ? <div className="spinner-bgdatil"></div> : //buffering logic
//                             <tbody>
//                                 {ImprestList.map((i, index) => {
//                                     const nextApproval = i.tender_amount_details.dynamic_approval.find(
//                                         (approval) => approval.level === i.level + 1
//                                     );
//                                     const shouldShowButtons =
//                                         !nextApproval ||
//                                         nextApproval.approval_status !== 'approved';

//                                     return (
//                                         <React.Fragment key={index}>

//                                             <tr className="custom-table-head-td" title={`Status : ${i.approval_status}`}>
//                                                 <td className="table-body text-lefttt">{index + 1}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.bank_name}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.request_type}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.amount}</td>
//                                                 <td className="table-body" title={`Amount change reason : ${i.amount_change_reason}`}>{i.tender_amount_details?.approved_amount}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.document ? <a href={i.tender_amount_details?.document} target="blank">
//                                                     <div className="flex-row justify-center">
//                                                         <DocumentIcon />
//                                                     </div>
//                                                 </a> : "No Document Attached"}</td>
//                                                 <td className="table-body">{formatDate(i.tender_amount_details?.date)}</td>
//                                                 <td className="table-body">{formatDate(i.tender_amount_details?.expiry_date)}</td>
//                                                 <td className="table-body">{formatDate(i.tender_amount_details?.release_date)}</td>
//                                                 {/* <td className="table-body">{i.tender_amount_details?.bid}</td> */}
//                                                 <td className="table-body">{i.tender_amount_details?.bid?.type_of_project || 'No Bid Project Type'}</td>








//                                                 <ViewDynamicApprovalStatus dynamic_approval={i.tender_amount_details?.dynamic_approval} />

//                                                 <ViewDynamicApprovalRemarks dynamic_approval={i.tender_amount_details?.dynamic_approval} />

//                                                 <td className="table-body">

//                                                     <div className="flex-row">
//                                                         {shouldShowButtons ?
//                                                             <div className="flex-row">
//                                                                 {
//                                                                     (i.approval_status === 'pending' || i.approval_status === 'rejected') && (
//                                                                         <>
//                                                                             {i.permissions === 'Finalize' ? (
//                                                                                 <DynamicRequestTenderFinalize i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                             ) : (
//                                                                                 <DynamicRequestTenderApproval i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                             )}
//                                                                             {i.permissions === 'Approve-Reject-Edit' && (
//                                                                                 <DynamicRequestTenderEditApproval i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                             )}
//                                                                         </>
//                                                                     )
//                                                                 }
//                                                                 {
//                                                                     (i.approval_status === 'pending' || i.approval_status === 'approved') && (
//                                                                         // "reject?"
//                                                                         <DynamicRequestTenderRejection i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                     )
//                                                                 }
//                                                             </div>
//                                                             :
//                                                             <div>
//                                                                 Next Stage Action Performed
//                                                             </div>
//                                                         }
//                                                     </div>
//                                                 </td>
//                                             </tr>
//                                         </React.Fragment>
//                                     )
//                                 })}
//                             </tbody>}
//                     </table>
//                 </div>
//             </div >
//         </>
//     );
// };

// const DynamicOutdutyApprovalTable = ({ showdashboard, level, approval_stages }) => {

//     const [buffer, setBuffering] = useState(true); //buffering logic
//     const [buffer1, setBuffering1] = useState(true); //buffering logic
//     const [ImprestList, setImprestList] = useState([]);
//     const [previousStatus, setPreviousStatus] = useState("approved");
//     const [selectedStatus, setSelectedStatus] = useState("pending");
//     const [selectedProject, setProject] = useState("null");
//     const [fromdate, setFromDate] = useState("null");
//     const [todate, setToDate] = useState("null");
//     const [selectedDivision, setDivision] = useState(
//         `${sessionStorage.getItem("company_id") || null}`
//     );
//     const [SubCompany, setSubCompany] = useState([]);

//     const getSubCompany = async () => {
//         setBuffering1(true); //buffering logic // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//             setSubCompany(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering1(false); //buffering logic // End Buffering
//         }
//     };

//     useEffect(() => {
//         getSubCompany();
//     }, [])

//     //! ******************************API start***************************//
//     const getDynamicTenderRequestData = async () => {
//         try {
//             setBuffering(true); //buffering logic // Start Buffering
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/tenderrequestamountdynamicapprovalspreviousfilter/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/`
//             );
//             setImprestList(res.data)
//             console.log(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };

//     useEffect(() => {
//         console.log(level, "tender useefect")
//         if (level != 0) {
//             getDynamicTenderRequestData();
//         }

//     }, [level, selectedStatus])

//     return (
//         <>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             <div className="attendance-history-cont">
//                 <div className="attendance-heading  font-weight500 font-size-heading"> </div>
//                 <div className="attendance-subcont">
//                     <div className="field-cont">
//                         <div className="field-cont-div">
//                             <div title=' Date Range' className="date-uppercase ">
//                                 <DateRangePicker startDate={fromdate} endDate={todate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
//                                     setFromDate(start);
//                                     setToDate(end);
//                                 }} />
//                             </div>
//                             <hr className="field-cont-hr" />
//                         </div>
//                         <div title='All' className="field-cont-div">
//                             <Filter />
//                             <select
//                                 className="attendance-input-field width-10vw   date-field"
//                                 type="text"
//                                 value={selectedStatus}
//                                 // onChange={(e) => setSelectedStatus(e.target.value)}
//                                 onChange={(e) => {
//                                     const value = e.target.value;
//                                     setSelectedStatus(value);
//                                     setPreviousStatus(value === "rejected" ? "pending" : "approved");
//                                 }}
//                                 style={{ cursor: 'pointer' }}
//                             >
//                                 <option value="null">All</option>
//                                 <option value="pending">Pending</option>
//                                 <option value="approved">Approved</option>
//                                 <option value="rejected">Rejected</option>
//                             </select>
//                             <hr className="field-cont-hr" />
//                         </div>
//                         <div title='Sub Companies' className="field-cont-div">
//                             {buffer ? <div className="spinner-vsmall"></div> : <Office />}
//                             <select
//                                 className="attendance-input-field width-10vw date-field"
//                                 type="text"
//                                 value={selectedDivision}
//                                 onChange={(e) => setDivision(e.target.value)}
//                             >
//                                 <option value="null">All Sub Companies</option>
//                                 {SubCompany.sort((a, b) => a.title - b.title).map(
//                                     (i, index) => (
//                                         <option value={i.id}>{i.title}</option>
//                                     )
//                                 )}
//                                 ;
//                             </select>
//                             <hr className="field-cont-hr" />
//                         </div>
//                         <div className="field-cont-div">
//                             <Projects value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
//                         </div>
//                     </div>
//                     <div className="btn-cont"></div>
//                     <div className="">
//                         <div>
//                             {/* <DownloadTenderBill projectList={ImprestList} /> */}
//                         </div>
//                     </div>
//                 </div>

//                 <div className="table-css-white-background scroll-container-table">
//                     <div className="table-heading-flex">
//                         <div className="repo-heading font-weight500 font-size-heading">Stage {level} of Tender</div>
//                     </div>
//                     <table className="table-css">
//                         <thead className="table-heading stciky-heading-top">
//                             <tr className="custom-table-head-tr">
//                                 <th className="table-heading-text text-lefttt">S. No.</th>
//                                 <th className="table-heading-text" style={{ textAlign: "center" }}>Bank Name</th>
//                                 <th className="table-heading-text">Request Type</th>
//                                 <th className="table-heading-text">Amount</th>
//                                 <th className="table-heading-text">Approved Amount</th>
//                                 <th className="table-heading-text" style={{ textAlign: "center" }}>Document</th>
//                                 <th className="table-heading-text">Date</th>
//                                 <th className="table-heading-text">Expiry Date</th>
//                                 <th className="table-heading-text">Release Date</th>

//                                 <th className="table-heading-text">Bid</th>
//                                 <th className="table-heading-text">Remarks</th>
//                                 <th className="table-heading-text">Status</th>
//                                 <th className="table-heading-text text-end">Action</th>
//                             </tr>
//                         </thead>
//                         {buffer ? <div className="spinner-bgdatil"></div> : //buffering logic
//                             <tbody>
//                                 {ImprestList.map((i, index) => {
//                                     const nextApproval = i.tender_amount_details.dynamic_approval.find(
//                                         (approval) => approval.level === i.level + 1
//                                     );
//                                     const shouldShowButtons =
//                                         !nextApproval ||
//                                         nextApproval.approval_status !== 'approved';

//                                     return (
//                                         <React.Fragment key={index}>

//                                             <tr className="custom-table-head-td" title={`Status : ${i.approval_status}`}>
//                                                 <td className="table-body text-lefttt">{index + 1}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.bank_name}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.request_type}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.amount}</td>
//                                                 <td className="table-body" title={`Amount change reason : ${i.amount_change_reason}`}>{i.tender_amount_details?.approved_amount}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.document ? <a href={i.tender_amount_details?.document} target="blank">
//                                                     <div className="flex-row justify-center">
//                                                         <DocumentIcon />
//                                                     </div>
//                                                 </a> : "No Document Attached"}</td>
//                                                 <td className="table-body">{formatDate(i.tender_amount_details?.date)}</td>
//                                                 <td className="table-body">{formatDate(i.tender_amount_details?.expiry_date)}</td>
//                                                 <td className="table-body">{formatDate(i.tender_amount_details?.release_date)}</td>
//                                                 {/* <td className="table-body">{i.tender_amount_details?.bid}</td> */}
//                                                 <td className="table-body">{i.tender_amount_details?.bid?.type_of_project || 'No Bid Project Type'}</td>








//                                                 <ViewDynamicApprovalStatus dynamic_approval={i.tender_amount_details?.dynamic_approval} />

//                                                 <ViewDynamicApprovalRemarks dynamic_approval={i.tender_amount_details?.dynamic_approval} />

//                                                 <td className="table-body">

//                                                     <div className="flex-row">
//                                                         {shouldShowButtons ?
//                                                             <div className="flex-row">
//                                                                 {
//                                                                     (i.approval_status === 'pending' || i.approval_status === 'rejected') && (
//                                                                         <>
//                                                                             {i.permissions === 'Finalize' ? (
//                                                                                 <DynamicRequestTenderFinalize i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                             ) : (
//                                                                                 <DynamicRequestTenderApproval i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                             )}
//                                                                             {i.permissions === 'Approve-Reject-Edit' && (
//                                                                                 <DynamicRequestTenderEditApproval i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                             )}
//                                                                         </>
//                                                                     )
//                                                                 }
//                                                                 {
//                                                                     (i.approval_status === 'pending' || i.approval_status === 'approved') && (
//                                                                         // "reject?"
//                                                                         <DynamicRequestTenderRejection i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                     )
//                                                                 }
//                                                             </div>
//                                                             :
//                                                             <div>
//                                                                 Next Stage Action Performed
//                                                             </div>
//                                                         }
//                                                     </div>
//                                                 </td>
//                                             </tr>
//                                         </React.Fragment>
//                                     )
//                                 })}
//                             </tbody>}
//                     </table>
//                 </div>
//             </div >
//         </>
//     );
// };

// const DynamicCompOffApprovalTable = ({ showdashboard, level, approval_stages }) => {

//     const [buffer, setBuffering] = useState(true); //buffering logic
//     const [buffer1, setBuffering1] = useState(true); //buffering logic
//     const [ImprestList, setImprestList] = useState([]);
//     const [previousStatus, setPreviousStatus] = useState("approved");
//     const [selectedStatus, setSelectedStatus] = useState("pending");
//     const [selectedProject, setProject] = useState("null");
//     const [fromdate, setFromDate] = useState("null");
//     const [todate, setToDate] = useState("null");
//     const [selectedDivision, setDivision] = useState(
//         `${sessionStorage.getItem("company_id") || null}`
//     );
//     const [SubCompany, setSubCompany] = useState([]);

//     const getSubCompany = async () => {
//         setBuffering1(true); //buffering logic // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//             setSubCompany(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering1(false); //buffering logic // End Buffering
//         }
//     };

//     useEffect(() => {
//         getSubCompany();
//     }, [])

//     //! ******************************API start***************************//
//     const getDynamicTenderRequestData = async () => {
//         try {
//             setBuffering(true); //buffering logic // Start Buffering
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/tenderrequestamountdynamicapprovalspreviousfilter/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/`
//             );
//             setImprestList(res.data)
//             console.log(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };

//     useEffect(() => {
//         console.log(level, "tender useefect")
//         if (level != 0) {
//             getDynamicTenderRequestData();
//         }

//     }, [level, selectedStatus])

//     return (
//         <>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             <div className="attendance-history-cont">
//                 <div className="attendance-heading  font-weight500 font-size-heading"> </div>
//                 <div className="attendance-subcont">
//                     <div className="field-cont">
//                         <div className="field-cont-div">
//                             <div title=' Date Range' className="date-uppercase ">
//                                 <DateRangePicker startDate={fromdate} endDate={todate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
//                                     setFromDate(start);
//                                     setToDate(end);
//                                 }} />
//                             </div>
//                             <hr className="field-cont-hr" />
//                         </div>
//                         <div title='All' className="field-cont-div">
//                             <Filter />
//                             <select
//                                 className="attendance-input-field width-10vw   date-field"
//                                 type="text"
//                                 value={selectedStatus}
//                                 // onChange={(e) => setSelectedStatus(e.target.value)}
//                                 onChange={(e) => {
//                                     const value = e.target.value;
//                                     setSelectedStatus(value);
//                                     setPreviousStatus(value === "rejected" ? "pending" : "approved");
//                                 }}
//                                 style={{ cursor: 'pointer' }}
//                             >
//                                 <option value="null">All</option>
//                                 <option value="pending">Pending</option>
//                                 <option value="approved">Approved</option>
//                                 <option value="rejected">Rejected</option>
//                             </select>
//                             <hr className="field-cont-hr" />
//                         </div>
//                         <div title='Sub Companies' className="field-cont-div">
//                             {buffer ? <div className="spinner-vsmall"></div> : <Office />}
//                             <select
//                                 className="attendance-input-field width-10vw date-field"
//                                 type="text"
//                                 value={selectedDivision}
//                                 onChange={(e) => setDivision(e.target.value)}
//                             >
//                                 <option value="null">All Sub Companies</option>
//                                 {SubCompany.sort((a, b) => a.title - b.title).map(
//                                     (i, index) => (
//                                         <option value={i.id}>{i.title}</option>
//                                     )
//                                 )}
//                                 ;
//                             </select>
//                             <hr className="field-cont-hr" />
//                         </div>
//                         <div className="field-cont-div">
//                             <Projects value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
//                         </div>
//                     </div>
//                     <div className="btn-cont"></div>
//                     <div className="">
//                         <div>
//                             {/* <DownloadTenderBill projectList={ImprestList} /> */}
//                         </div>
//                     </div>
//                 </div>

//                 <div className="table-css-white-background scroll-container-table">
//                     <div className="table-heading-flex">
//                         <div className="repo-heading font-weight500 font-size-heading">Stage {level} of Tender</div>
//                     </div>
//                     <table className="table-css">
//                         <thead className="table-heading stciky-heading-top">
//                             <tr className="custom-table-head-tr">
//                                 <th className="table-heading-text text-lefttt">S. No.</th>
//                                 <th className="table-heading-text" style={{ textAlign: "center" }}>Bank Name</th>
//                                 <th className="table-heading-text">Request Type</th>
//                                 <th className="table-heading-text">Amount</th>
//                                 <th className="table-heading-text">Approved Amount</th>
//                                 <th className="table-heading-text" style={{ textAlign: "center" }}>Document</th>
//                                 <th className="table-heading-text">Date</th>
//                                 <th className="table-heading-text">Expiry Date</th>
//                                 <th className="table-heading-text">Release Date</th>

//                                 <th className="table-heading-text">Bid</th>
//                                 <th className="table-heading-text">Remarks</th>
//                                 <th className="table-heading-text">Status</th>
//                                 <th className="table-heading-text text-end">Action</th>
//                             </tr>
//                         </thead>
//                         {buffer ? <div className="spinner-bgdatil"></div> : //buffering logic
//                             <tbody>
//                                 {ImprestList.map((i, index) => {
//                                     const nextApproval = i.tender_amount_details.dynamic_approval.find(
//                                         (approval) => approval.level === i.level + 1
//                                     );
//                                     const shouldShowButtons =
//                                         !nextApproval ||
//                                         nextApproval.approval_status !== 'approved';

//                                     return (
//                                         <React.Fragment key={index}>

//                                             <tr className="custom-table-head-td" title={`Status : ${i.approval_status}`}>
//                                                 <td className="table-body text-lefttt">{index + 1}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.bank_name}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.request_type}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.amount}</td>
//                                                 <td className="table-body" title={`Amount change reason : ${i.amount_change_reason}`}>{i.tender_amount_details?.approved_amount}</td>
//                                                 <td className="table-body">{i.tender_amount_details?.document ? <a href={i.tender_amount_details?.document} target="blank">
//                                                     <div className="flex-row justify-center">
//                                                         <DocumentIcon />
//                                                     </div>
//                                                 </a> : "No Document Attached"}</td>
//                                                 <td className="table-body">{formatDate(i.tender_amount_details?.date)}</td>
//                                                 <td className="table-body">{formatDate(i.tender_amount_details?.expiry_date)}</td>
//                                                 <td className="table-body">{formatDate(i.tender_amount_details?.release_date)}</td>
//                                                 {/* <td className="table-body">{i.tender_amount_details?.bid}</td> */}
//                                                 <td className="table-body">{i.tender_amount_details?.bid?.type_of_project || 'No Bid Project Type'}</td>








//                                                 <ViewDynamicApprovalStatus dynamic_approval={i.tender_amount_details?.dynamic_approval} />

//                                                 <ViewDynamicApprovalRemarks dynamic_approval={i.tender_amount_details?.dynamic_approval} />

//                                                 <td className="table-body">

//                                                     <div className="flex-row">
//                                                         {shouldShowButtons ?
//                                                             <div className="flex-row">
//                                                                 {
//                                                                     (i.approval_status === 'pending' || i.approval_status === 'rejected') && (
//                                                                         <>
//                                                                             {i.permissions === 'Finalize' ? (
//                                                                                 <DynamicRequestTenderFinalize i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                             ) : (
//                                                                                 <DynamicRequestTenderApproval i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                             )}
//                                                                             {i.permissions === 'Approve-Reject-Edit' && (
//                                                                                 <DynamicRequestTenderEditApproval i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                             )}
//                                                                         </>
//                                                                     )
//                                                                 }
//                                                                 {
//                                                                     (i.approval_status === 'pending' || i.approval_status === 'approved') && (
//                                                                         // "reject?"
//                                                                         <DynamicRequestTenderRejection i={i} getDynamicRequestData={getDynamicTenderRequestData} />
//                                                                     )
//                                                                 }
//                                                             </div>
//                                                             :
//                                                             <div>
//                                                                 Next Stage Action Performed
//                                                             </div>
//                                                         }
//                                                     </div>
//                                                 </td>
//                                             </tr>
//                                         </React.Fragment>
//                                     )
//                                 })}
//                             </tbody>}
//                     </table>
//                 </div>
//             </div >
//         </>
//     );
// };

const DynamicImprestApprovalTable = ({ showdashboard, level, approval_stages }) => {

    const [buffer, setBuffering] = useState(true); //buffering logic
    const [buffer1, setBuffering1] = useState(true); //buffering logic
    const [ImprestList, setImprestList] = useState([]);
    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("company_id") || null}`
    );
    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering1(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getSubCompany();
    }, [])

    //! ******************************API start***************************//
    const getDynamicImprestRequestData = async () => {
        try {
            setBuffering(true); //buffering logic // Start Buffering
            const res = await axios.get(
                // `${BASE_URL}/siteproject/dynamicimprestonlyapprovals/${level}/${selectedStatus}/`
                `${BASE_URL}/siteproject/dynamicimprestapprovals/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/`
            );
            setImprestList(res.data)
            console.log(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        console.log(level, "imprest useefect")
        if (level != 0) {
            getDynamicImprestRequestData();
        }

    }, [level, selectedStatus])

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className="attendance-history-cont">
                <div className="attendance-heading  font-weight500 font-size-heading"> </div>
                <div className="attendance-subcont">
                    <div className="field-cont">
                        {/* <div className="field-cont-div">
                            <div title=' Date Range' className="date-uppercase ">
                                <DateRangePicker startDate={fromdate} endDate={todate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
                                    setFromDate(start);
                                    setToDate(end);
                                }} />
                            </div>
                            <hr className="field-cont-hr" />
                        </div> */}
                        <div title='All' className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={selectedStatus}
                                // onChange={(e) => setSelectedStatus(e.target.value)}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectedStatus(value);
                                    setPreviousStatus(value === "rejected" ? "pending" : "approved");
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <option value="null">All</option>
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div title='Sub Companies' className="field-cont-div">
                            {buffer ? <div className="spinner-vsmall"></div> : <Office />}
                            <select
                                className="attendance-input-field width-10vw date-field"
                                type="text"
                                value={selectedDivision}
                                onChange={(e) => setDivision(e.target.value)}
                                style={{ cursor: 'pointer' }}
                            >
                                <option value="null">All Sub Companies</option>
                                {SubCompany.sort((a, b) => a.title - b.title).map(
                                    (i, index) => (
                                        <option value={i.id}>{i.title}</option>
                                    )
                                )}
                                ;
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            {/* <Projects value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} /> */}
                        </div>
                    </div>
                    <div className="btn-cont"></div>
                    <div className="">
                        <div>
                            {/* <DownloadImprestBill projectList={ImprestList} /> */}
                        </div>
                    </div>
                </div>

                <div className="table-css-white-background scroll-container-table">
                    <div className="table-heading-flex">
                        <div className="repo-heading font-weight500 font-size-heading">Stage {level} of Imprest</div>
                    </div>
                    <table className="table-css">
                        <thead className="table-heading stciky-heading-top">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text text-lefttt">S. No.</th>
                                <th className="table-heading-text" style={{ textAlign: "center" }}>Project</th>
                                <th className="table-heading-text">Imprest Date</th>
                                <th className="table-heading-text">Dates</th>
                                <th className="table-heading-text">Imprest Name</th>
                                <th className="table-heading-text" style={{ textAlign: "center" }}>Total Amount</th>
                                <th className="table-heading-text">Days</th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Remarks</th>
                                <th className="table-heading-text text-end">Action</th>
                            </tr>
                        </thead>
                        {buffer ? <div className="spinner-bgdatil"></div> : //buffering logic
                            <tbody>
                                {ImprestList.map((i, index) => {
                                    const nextApproval = i.imprest_details.dynamic_approval.find(
                                        (approval) => approval.level === i.level + 1
                                    );
                                    const shouldShowButtons =
                                        !nextApproval ||
                                        nextApproval.approval_status !== 'approved';

                                    return (
                                        <React.Fragment key={index}>

                                            <tr className="custom-table-head-td" title={`Team Leader Status : ${i.imprest_details?.authority_approval_status}`}>
                                                <td className="table-body text-lefttt">{index + 1}</td>
                                                <td className="table-body"> {i.imprest_details?.project_code}/{i.imprest_details?.project_short_name}</td>
                                                <td className="table-body">{formatDate(i.imprest_details?.date)}</td>

                                                <ViewDynamicApprovalDates dynamic_approval={i.imprest_details?.dynamic_approval} />

                                                <td className="table-body">{i.imprest_details?.imprest_name}</td>

                                                <td className="table-body" title={`${i.imprest_details?.change_log?.length > 1 ? 'Approved Amount' : 'Proposed Amount'}`}>
                                                    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                                        <tbody>
                                                            {[
                                                                { name: 'Stationary', value: i.imprest_details?.change_log?.length > 1 ? i.imprest_details?.approved_stationary_item : i.imprest_details?.stationary_item },
                                                                { name: 'Electronics', value: i.imprest_details?.change_log?.length > 1 ? i.imprest_details?.approved_electronic_item : i.imprest_details?.electronic_item },
                                                                { name: 'Grocery', value: i.imprest_details?.change_log?.length > 1 ? i.imprest_details?.approved_grocery : i.imprest_details?.grocery },
                                                            ].map(({ name, value }) => (
                                                                Number(value) !== 0 &&
                                                                (
                                                                    <tr key={name}>
                                                                        <td className="table-body" style={{ paddingBottom: "5px" }}>{name}</td>
                                                                        <td style={{ padding: "0px 4px" }}>:</td>
                                                                        <td className="align-right">{formatCurrencyIndian(value)}</td>
                                                                    </tr>
                                                                )
                                                            ))}

                                                            {i.imprest_details?.other_details?.length > 0 && i.imprest_details?.other_details.map((other, index) => (
                                                                <tr key={other.other_name || `other-${index}`}>
                                                                    <td style={{ paddingBottom: "5px" }} className="table-body">
                                                                        {other.other_name || `Other-${index + 1}`}
                                                                    </td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        {formatCurrencyIndian(Number(i.imprest_details?.change_log?.length > 1 ? other.approved_other : other.amount))}
                                                                    </td>
                                                                </tr>
                                                            ))}

                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }} >
                                                                    <b>Total </b>
                                                                </td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="text-end">
                                                                    <b>
                                                                        {formatCurrencyIndian(
                                                                            Number(i.imprest_details?.change_log?.length > 1 ? i.imprest_details?.approved_stationary_item : i.imprest_details?.stationary_item) +
                                                                            Number(i.imprest_details?.change_log?.length > 1 ? i.imprest_details?.approved_electronic_item : i.imprest_details?.electronic_item) +
                                                                            Number(i.imprest_details?.change_log?.length > 1 ? i.imprest_details?.approved_grocery : i.imprest_details?.grocery) +
                                                                            (i?.imprest_details?.other_details?.length > 0
                                                                                ? i?.imprest_details?.other_details?.reduce((total, other) => total + Number(i.imprest_details?.change_log?.length > 1 ? other.approved_other : other.amount), 0)
                                                                                : 0)
                                                                        )}
                                                                    </b>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>


                                                <td className="table-body"> <b>{i.imprest_details?.no_of_days}</b> </td>

                                                <ViewDynamicApprovalStatus dynamic_approval={i.imprest_details?.dynamic_approval} />

                                                <ViewDynamicApprovalRemarks dynamic_approval={i.imprest_details?.dynamic_approval} />

                                                <td className="table-body">

                                                    <div className="flex-row">

                                                        {/* {i.permissions === 'Finalize' ?
                                                        <DynamicRequestImprestFinalize i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                        :
                                                        <DynamicRequestImprestApproval i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                    }
                                                    {i.permissions === 'Approve-Reject-Edit' &&
                                                        <DynamicRequestImprestEditApproval i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                    }
                                                    <DynamicRequestImprestRejection i={i} getDynamicRequestData={getDynamicImprestRequestData} /> */}
                                                        {shouldShowButtons ?
                                                            <div className="flex-row">
                                                                {
                                                                    (i.approval_status === 'pending' || i.approval_status === 'rejected') && (
                                                                        <>
                                                                            {i.permissions === 'Finalize' ? (
                                                                                <DynamicRequestImprestFinalize i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                                            ) : (
                                                                                <DynamicRequestImprestApproval i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                                            )}
                                                                            {i.permissions === 'Approve-Reject-Edit' && (
                                                                                <DynamicRequestImprestEditApproval i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                                            )}
                                                                        </>
                                                                    )
                                                                }
                                                                {
                                                                    (i.approval_status === 'pending' || i.approval_status === 'approved') && (
                                                                        // "reject?"
                                                                        <DynamicRequestImprestRejection i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                                    )
                                                                }
                                                            </div>
                                                            :
                                                            <div>
                                                                Next Stage Action Performed
                                                            </div>
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    )
                                })}
                            </tbody>}
                    </table>
                </div>
            </div >
        </>
    );
};

const DynamicsExpenseApproveTable = ({ showdashboard, level, approval_stages }) => {

    const [buffer, setBuffering] = useState(true); //buffering logic
    const [buffer1, setBuffering1] = useState(true); //buffering logic

    const [ExpenseList, setExpenseList] = useState([]);

    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");

    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("company_id") || null}`
    );


    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering1(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/ `);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getSubCompany();
    }, [])

    //! ******************************API start***************************//
    const getDynamicExpenseRequestData = async () => {
        try {
            setBuffering(true); //buffering logic // Start Buffering
            const res = await axios.get(
                // `${BASE_URL}/siteproject/dynamicimprestonlyapprovals/${level}/${selectedStatus}/`
                // `${BASE_URL}/siteproject/dynamicexpenseapprovals/${level}/${selectedStatus}/`
                `${BASE_URL}/siteproject/expensedynamicapprovalsprevious/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/`
            );
            setExpenseList(res.data)
            console.log(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        console.log(level, "Expense useeffect")
        if (level != 0) {
            getDynamicExpenseRequestData();
        }

    }, [level, selectedStatus])

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const baseUrl = "/" + urlParts[3] + `/requestExpenseSlip/`;
    const opener = sessionStorage.getItem('sitemanagement_role')
    const openExenseSlip = (i, reqData) => {
        navigate(baseUrl + i.id + '/', { state: { i, reqData, opener } });
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div>
                <div className="attendance-history-cont">
                    <div className="attendance-heading  font-weight500    font-size-heading">
                        {" "}
                    </div>
                    <div className="attendance-subcont">
                        <div className="field-cont">
                            {/* <div className="field-cont-div">
                                <div title=' Date Range' className="date-uppercase ">
                                    <DateRangePicker startDate={fromdate} endDate={todate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
                                        setFromDate(start);
                                        setToDate(end);
                                    }} />
                                </div>
                                <hr className="field-cont-hr" />
                            </div> */}
                            <div title='All' className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatus}
                                    // onChange={(e) => setSelectedStatus(e.target.value)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedStatus(value);
                                        setPreviousStatus(value === "rejected" ? "pending" : "approved");
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>

                            <div title='Sub Companies' className="field-cont-div">
                                {buffer ? <div className="spinner-vsmall"></div> : <Office />}
                                <select
                                    className="attendance-input-field width-10vw date-field"
                                    type="text"
                                    value={selectedDivision}
                                    onChange={(e) => setDivision(e.target.value)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <option value="null">All Sub Companies</option>
                                    {SubCompany.sort((a, b) => a.title - b.title).map(
                                        (i, index) => (
                                            <option value={i.id}>{i.title}</option>
                                        )
                                    )}
                                    ;
                                </select>

                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                {/* <Projects value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} /> */}
                            </div>

                        </div>
                        <div className="btn-cont"></div>
                    </div>

                    <div className="table-css-white-background scroll-container-table">

                        <table className="table-css">
                            <thead className="table-heading stciky-heading-top">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text text-lefttt">S. No.</th>
                                    <th className="table-heading-text">Date</th>
                                    <th className="table-heading-text">Expense Name</th>
                                    <th className="table-heading-text">Project</th>
                                    <th className="table-heading-text">Imprest Amount</th>
                                    <th className="table-heading-text">Expense Amount</th>
                                    <th className="table-heading-text">Status</th>
                                    <th className="table-heading-text">Remarks</th>
                                    <th className="table-heading-text text-end">Action</th>
                                </tr>
                            </thead>
                            {buffer ? <div className="spinner-bgdatil"></div> : //buffering logic
                                <tbody>
                                    {ExpenseList.map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="table-body text-lefttt">{index + 1}</td>
                                                <td className="table-body">{formatDate(i.expense_details?.date)}</td>
                                                <td className="table-body">{i.expense_details?.name}</td>
                                                <td className="table-body">
                                                    {i.expense_details?.imprest_data?.project_short_name || "N/A"}
                                                </td>
                                                {/* <td className="table-body">
                                                    {formatCurrencyIndian(
                                                        Number(i.expense_details?.utilized_amount || 0) +
                                                        Number(i.expense_details?.remaining_amount || 0)
                                                    )}
                                                </td> */}
                                                {i.expense_details?.imprest_data?.amount_change_reason ? (
                                                    <td
                                                        className="table-body"
                                                        title={`Reason For Change : \n${i.expense_details?.imprest_data?.amount_change_reason}`}
                                                    >
                                                        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                                            <tbody>
                                                                {[
                                                                    { name: 'Approved Stationary', value: i.expense_details?.imprest_data?.approved_stationary_item, proposed: i.expense_details?.imprest_data?.stationary_item },
                                                                    { name: 'Approved Electronics', value: i.expense_details?.imprest_data?.approved_electronic_item, proposed: i.expense_details?.imprest_data?.electronic_item },
                                                                    { name: 'Approved Grocery', value: i.expense_details?.imprest_data?.approved_grocery, proposed: i.expense_details?.imprest_data?.grocery }
                                                                ].map(({ name, value, proposed }) => (
                                                                    // Number(value) !== 0 && 
                                                                    Number(proposed) !== 0 &&
                                                                    (
                                                                        <tr key={name}>
                                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>{name}</td>
                                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                                            <td className="align-right">{formatCurrencyIndian(value)}</td>
                                                                        </tr>
                                                                    )
                                                                ))}

                                                                {i.expense_details?.imprest_data?.other_details?.length > 0 && i.expense_details?.imprest_data?.other_details.map((other, index) => (
                                                                    <tr key={other.other_name || `other-${index}`}>
                                                                        <td style={{ paddingBottom: "5px" }} className="table-body">
                                                                            {other.other_name || `Other-${index + 1}`}
                                                                        </td>
                                                                        <td style={{ padding: "0px 4px" }}>:</td>
                                                                        <td className="align-right">
                                                                            {formatCurrencyIndian(other.approved_other || 0)}
                                                                        </td>
                                                                    </tr>
                                                                ))}

                                                                <tr>
                                                                    <td>
                                                                        <b>Total</b>
                                                                    </td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="text-end">
                                                                        <b>
                                                                            {formatCurrencyIndian(
                                                                                Number(i.expense_details?.imprest_data?.approved_stationary_item) +
                                                                                Number(i.expense_details?.imprest_data?.approved_electronic_item) +
                                                                                Number(i.expense_details?.imprest_data?.approved_grocery) +
                                                                                (i.expense_details?.imprest_data?.other_details?.length > 0
                                                                                    ? i.expense_details?.imprest_data?.other_details?.reduce(
                                                                                        (total, other) =>
                                                                                            total + Number(other.approved_other || 0),
                                                                                        0
                                                                                    )
                                                                                    : 0)
                                                                            )}
                                                                        </b>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                ) : (
                                                    <td className="table-body" style={{ textAlign: "center" }}>-</td>
                                                )}
                                                {
                                                    i.expense_details?.submit_for_approval === false ?
                                                        <td className="table-body align-center">
                                                            <span
                                                                request-status={"pending"}
                                                                className="request-status"
                                                            >
                                                                Expense Not Submitted
                                                            </span>
                                                        </td>
                                                        :
                                                        <td className="table-body">
                                                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="table-body" style={{ paddingBottom: "5px" }}>Utilized Bills</td>
                                                                        <td style={{ padding: "0px 4px" }}>:</td>
                                                                        <td className="align-right">
                                                                            {i.expense_details?.utilized_amount ? formatRoundoff2D(i.expense_details?.utilized_amount) : '-'}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="table-body" style={{ paddingBottom: "5px" }}>Remaining Balance</td>
                                                                        <td style={{ padding: "0px 4px" }}>:</td>
                                                                        <td className="align-right">
                                                                            {i.expense_details?.remaining_amount ? formatRoundoff2D(i.expense_details?.remaining_amount) : '-'}
                                                                        </td>
                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </td>
                                                }

                                                <ViewDynamicApprovalStatus dynamic_approval={i.expense_details?.dynamic_approval} />

                                                <ViewDynamicApprovalRemarks dynamic_approval={i.expense_details?.dynamic_approval} />

                                                <td className="table-body">
                                                    <div className="flex-row">
                                                        {i.permissions === 'Finalize' &&
                                                            <DynamicRequestExpenseFinalize i={i} j={i.expense_details} getDynamicRequestData={getDynamicExpenseRequestData} />
                                                        }
                                                        <button
                                                            className="allproject-dashboard"
                                                            title="View using Navigate"
                                                            onClick={(e) => openExenseSlip(i.expense_details, i)}
                                                        >
                                                            <Eye />
                                                        </button>
                                                    </div>
                                                </td>

                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>}
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};


const DynamicBankDetailsChangeApprovalTable = ({ level, version, formatData, getApprovalStages, formatFor }) => {
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(false);
    const [BankList, setBankList] = useState([]);
    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("company_id") || null}`
    );
    const approver = sessionStorage.getItem('emp_code')

    //! ****************************** API start ***************************//
    const getDynamicBankRequestData = async () => {
        try {

            setBuffering(true);
            const res = await axios.get(
                `${BASE_URL}/wfm/dynamicapproval-stagesdata-byversionedformat/${formatFor}/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/${approver}/${version}/`
            );
            setBankList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        if (level !== 0) {
            getDynamicBankRequestData();
        }
    }, [level, selectedStatus, version]);

    const getVersionDisplay = () => {
        if (version === 'all') {
            return 'All Versions';
        }
        const versionFormat = formatData?.find(format => format.version === version);
        return `Version ${version} ${versionFormat?.is_active ? '(Current)' : '(Old)'}`;
    };


    // const canShowApprovalAction = ({ approvals, currentLevel, requestStatus }) => {
    //     if (!Array.isArray(approvals) || approvals.length === 0) return false;

    //     // Check if the overall request status is pending
    //     if (requestStatus !== "pending") return false;
    //     //current level must be pending
    //     const currentApproval = approvals.find(a => a.level === currentLevel);
    //     if (!currentApproval || currentApproval.approval_status !== "pending") {
    //         return false;
    //     }

    //     //previous level must be approved
    //     if (currentLevel > 1) {
    //         const prevApproval = approvals.find(a => a.level === currentLevel - 1);
    //         if (!prevApproval || prevApproval.approval_status !== "approved") {
    //             return false;
    //         }
    //     }

    //     //next level must not already be approved
    //     const nextApproval = approvals.find(a => a.level === currentLevel + 1);
    //     if (nextApproval && nextApproval.approval_status === "approved") {
    //         return false;
    //     }

    //     return true;
    // };

    const canShowApprovalAction = ({ approvals, currentLevel, requestStatus }) => {
        if (!Array.isArray(approvals) || approvals.length === 0) return false;


        if (!["pending", "approved"].includes(requestStatus)) return false;

        const currentApproval = approvals.find(a => Number(a.level) === Number(currentLevel));
        const prevApproval = approvals.find(a => Number(a.level) === Number(currentLevel) - 1);
        const nextApproval = approvals.find(a => Number(a.level) === Number(currentLevel) + 1);

        if (!currentApproval) return false;

        if (currentLevel > 1 && prevApproval?.approval_status !== "approved") {
            return false;
        }

        const canProceed =
            currentApproval.approval_status === "pending" ||
            (currentApproval.approval_status === "approved" &&
                nextApproval?.approval_status === "pending");



        if (!canProceed) return false;

        if (nextApproval?.approval_status === "approved") return false;

        return true;
    };


    const getApprovalComponent = (i, formatFor) => {
        const approvals = i.bank_details?.dynamic_approval || [];

        const canShow = canShowApprovalAction({
            approvals,
            currentLevel: level,
            requestStatus: i.approval_status
        });

        if (!canShow) {

            if (approvals.some(a => a.approval_status === "rejected")) {
                return "Request Closed";
            }

            if (approvals.every(a => a.approval_status === "approved")) {
                return "Fully Approved";
            }

            return "No Action Available";
        }

        const components = {
            bankdetails: (
                <BankDetailsDynamicApprovalActionModal
                    i={i}
                    approvalType={formatFor}
                    getDynamicRequestData={getDynamicBankRequestData}
                    getApprovalStages={getApprovalStages}
                />
            )
        };

        return components[formatFor] || "No Action Available";
    };


    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick />
            <div className="attendance-history-cont">
                <div className="attendance-subcont">
                    <div className="field-cont">
                        {SUPER_ADMIN && <div title="Sub Companies" className="field-cont-div">
                            {buffer1 ? <div className="spinner-vsmall"></div> : <Office />}
                            <select
                                className="attendance-input-field width-10vw date-field"
                                value={selectedDivision}
                                onChange={(e) => setDivision(e.target.value)}
                                style={{ cursor: "pointer" }}
                            >
                                <option value="null">All Sub Companies</option>
                                {SUB_COMPANIES.map((i) => (
                                    <option key={i.id} value={i.id}>{i.title}</option>
                                ))}
                            </select>
                            <hr className="field-cont-hr" />
                        </div>}
                        <div title="All" className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw date-field"
                                value={selectedStatus}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectedStatus(value);
                                    if (value === "rejected") {
                                        setPreviousStatus("pending");
                                    } else if (value === "null") {
                                        setPreviousStatus("null");
                                    } else {
                                        setPreviousStatus("approved");
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <option value="null">All</option>
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                    </div>
                </div>

                <div className="table-css-white-background scroll-container-table">
                    <div className="table-heading-flex">
                        <div
                            className="repo-heading font-weight500 font-size-heading"
                            title={`Viewing: ${getVersionDisplay()} • Stage ${level}`}
                            style={{ cursor: 'help' }}
                        >
                            Stage {level} of Bank Details Change - {getVersionDisplay()}
                        </div>
                    </div>

                    <table className="table-css">
                        <thead className="table-heading stciky-heading-top">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text text-lefttt">S. No.</th>
                                {version === 'all' && <th className="table-heading-text align-center">Version</th>}
                                <th className="table-heading-text align-center">Employee</th>
                                <th className="table-heading-text align-center">Previous Details</th>
                                <th className="table-heading-text align-center">Requested Changes</th>
                                <th className="table-heading-text align-center">Changed Fields</th>
                                <th className="table-heading-text align-center">Reason for Change</th>
                                <th className="table-heading-text align-center">Proof</th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Remarks</th>
                                <th className="table-heading-text text-end">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <Loader container={true} />
                        ) : (
                            <tbody>
                                {BankList.length > 0 ? (
                                    BankList.map((i, index) => {
                                        const bank = i.bank_details;
                                        // const nextApproval = bank.dynamic_approval.find(
                                        //     (approval) => approval.level === i.level + 1
                                        // );
                                        // const shouldShowButtons = !nextApproval || nextApproval.approval_status !== "approved";

                                        return (
                                            <tr key={i.id} className="custom-table-head-td">
                                                <td className="table-body">{index + 1}</td>
                                                {/*  Version Column for "All Versions" view */}
                                                {version === 'all' && (
                                                    <td className="table-body align-center">
                                                        <span className={`version-badge ${bank.approval_flow_version === formatData?.find(f => f.is_active)?.version ? 'version-current' : 'version-old'}`}>
                                                            v{bank.approval_flow_version}
                                                        </span>
                                                    </td>
                                                )}
                                                <td className="table-body" style={{ textAlign: "center" }}>
                                                    <CustomImageModal customStyle>
                                                        {bank.emp_profilepic ? (
                                                            <img
                                                                src={`${IMAGE_URL}${bank.emp_profilepic}`}
                                                                alt="profile" className="profile-img"
                                                            />
                                                        ) : (
                                                            <UserDefaultLogo user={{ name: bank.emp_name, profilepic: bank.emp_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                        )}
                                                    </CustomImageModal>
                                                    <p>{bank.emp_code}-{bank.emp_name}</p>
                                                </td>
                                                <td className="table-body">
                                                    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                                        <tbody>
                                                            {Object.entries(bank.previous_data || {}).map(([key, value]) => (
                                                                <tr key={key}>
                                                                    <td className="table-body text-capitalize" style={{ paddingBottom: "5px" }}>
                                                                        {FormatKey(key)}
                                                                    </td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        {value}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </td>

                                                <td className="table-body">
                                                    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                                        <tbody>
                                                            {Object.entries(bank.updated_data || {}).map(([key, value]) => (
                                                                <tr key={key}>
                                                                    <td className="table-body text-capitalize" style={{ paddingBottom: "5px" }}>
                                                                        {FormatKey(key)}
                                                                    </td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        {value}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </td>

                                                <td className="table-body">
                                                    {bank.changed_fields?.length > 0 ? (
                                                        <ul style={{ margin: 0, paddingLeft: "16px" }}>
                                                            {bank.changed_fields.map((field, idx) => (
                                                                <li key={idx} className='text-capitalize'>{FormatKey(field)}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>
                                                <td className="table-body">
                                                    {bank.reason_for_change || '-'}
                                                </td>
                                                <td>
                                                    {bank.proof_attachment ? (
                                                        <ViewFile
                                                            doc={bank.proof_attachment}
                                                            filename={"Proof Attachment"}
                                                            filesrc={bank.proof_attachment}
                                                        />
                                                    ) : (
                                                        'No File Attached'
                                                    )}
                                                </td>

                                                <ViewDynamicApprovalStatus dynamic_approval={bank.dynamic_approval} />
                                                <ViewDynamicApprovalRemarks dynamic_approval={bank.dynamic_approval} />

                                                <td className="table-body">

                                                    {getApprovalComponent(i, formatFor)}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={version === 'all' ? 11 : 10} className="text-center table-body">
                                            No requests found for Stage {level} {version !== 'all' && `(Version ${version})`}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

const DynamicInvestmentApprovalTable = ({ level, version, formatData, getApprovalStages, formatFor }) => {
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(false);
    const [InvestmentList, setInvestmentList] = useState([]);
    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("company_id") || null}`
    );
    const approver = sessionStorage.getItem('emp_code')

    const getDynamicInvestmentRequestData = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(
                `${BASE_URL}/wfm/dynamicapproval-stagesdata-byversionedformat-withlegacy/${formatFor}/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/${approver}/${version}/`
            );
            setInvestmentList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        if (level !== 0) {
            getDynamicInvestmentRequestData();
        }
    }, [level, selectedStatus, version]);

    const getVersionDisplay = () => {
        if (version === 'all') {
            return 'All Versions';
        }
        const versionFormat = formatData?.find(format => format.version === version);
        return `Version ${version} ${versionFormat?.is_active ? '(Current)' : '(Old)'}`;
    };



    const canShowApprovalAction = ({ approvals, currentLevel, requestStatus }) => {
        if (!Array.isArray(approvals) || approvals.length === 0) return false;


        if (!["pending", "approved"].includes(requestStatus)) return false;

        const currentApproval = approvals.find(a => Number(a.level) === Number(currentLevel));
        const prevApproval = approvals.find(a => Number(a.level) === Number(currentLevel) - 1);
        const nextApproval = approvals.find(a => Number(a.level) === Number(currentLevel) + 1);

        if (!currentApproval) return false;

        if (currentLevel > 1 && prevApproval?.approval_status !== "approved") {
            return false;
        }

        const canProceed =
            currentApproval.approval_status === "pending" ||
            (currentApproval.approval_status === "approved" &&
                nextApproval?.approval_status === "pending");



        if (!canProceed) return false;

        if (nextApproval?.approval_status === "approved") return false;

        return true;
    };




    const getDeclarationApprovalComponent = (i, formatFor) => {
        const approvals = i.investment_form?.declaration_dynamic_approval || [];

        const canShow = canShowApprovalAction({
            approvals,
            currentLevel: level,
            requestStatus: i.approval_status
        });



        if (!canShow) {

            if (approvals.some(a => a.approval_status === "rejected")) {
                return "Request Closed";
            }

            if (approvals.every(a => a.approval_status === "approved")) {
                return "Fully Approved";
            }

            return "No Action Available";
        }

        const components = {
            investment_declaration: <>{renderDynamicApprovalActionButtons("Investment Declaration", i)}</>,
        };

        return components[formatFor] || "No Action Available";
    };

    const getProofApprovalComponent = (i, formatFor) => {
        const approvals = i.investment_form?.proof_dynamic_approval || [];

        const canShow = canShowApprovalAction({
            approvals,
            currentLevel: level,
            requestStatus: i.approval_status
        });

        if (!canShow) {

            if (approvals.some(a => a.approval_status === "rejected")) {
                return "Request Closed";
            }

            if (approvals.every(a => a.approval_status === "approved")) {
                return "Fully Approved";
            }

            return "No Action Available";
        }

        const components = {
            investment_proof: <>{renderDynamicApprovalProofsActionButtons("Investment Proof", i)}</>,
        };

        return components[formatFor] || "No Action Available";
    };

    const renderDynamicApprovalActionButtons = (context, i) => ( //context = declaration

        <DynamicApprovalInvestmentDeclarationAction
            context={context}
            i={i}
            approvalType={formatFor}
            getDynamicRequestData={getDynamicInvestmentRequestData}
            getApprovalStages={getApprovalStages}
        />
    );


    const renderDynamicApprovalProofsActionButtons = (context, i) => ( //context = proof

        <DynamicApprovalInvestmentProofsAction
            context={context}
            i={i}
            approvalType={formatFor}
            getDynamicRequestData={getDynamicInvestmentRequestData}
            getApprovalStages={getApprovalStages}
        />
    );


    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick />
            <div className="attendance-history-cont">
                <div className="attendance-subcont">
                    <div className="field-cont">
                        {SUPER_ADMIN && <div title="Sub Companies" className="field-cont-div">
                            {buffer1 ? <div className="spinner-vsmall"></div> : <Office />}
                            <select
                                className="attendance-input-field width-10vw date-field"
                                value={selectedDivision}
                                onChange={(e) => setDivision(e.target.value)}
                                style={{ cursor: "pointer" }}
                            >
                                <option value="null">All Sub Companies</option>
                                {SUB_COMPANIES.map((i) => (
                                    <option key={i.id} value={i.id}>{i.title}</option>
                                ))}
                            </select>
                            <hr className="field-cont-hr" />
                        </div>}
                        <div title="All" className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw date-field"
                                value={selectedStatus}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectedStatus(value);
                                    if (value === "rejected") {
                                        setPreviousStatus("pending");
                                    } else if (value === "null") {
                                        setPreviousStatus("null");
                                    } else {
                                        setPreviousStatus("approved");
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <option value="null">All</option>
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                    </div>
                </div>

                <div className="table-css-white-background scroll-container-table">
                    <div className="table-heading-flex">
                        <div
                            className="repo-heading font-weight500 font-size-heading"
                            title={`Viewing: ${getVersionDisplay()} • Stage ${level} • ${formatFor === 'investment_declaration' ? 'Declaration' : 'Proof'} Approval`}
                            style={{ cursor: 'help' }}
                        >
                            Stage {level} of {formatFor === 'investment_declaration' ? 'Investment Declaration' : 'Investment Proof'} - {getVersionDisplay()}
                        </div>
                    </div>

                    <table className="table-css">
                        <thead className="table-heading stciky-heading-top">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text text-lefttt">S. No.</th>
                                {version === 'all' && <th className="table-heading-text align-center">Version</th>}
                                <th className="table-heading-text align-center">Employee</th>
                                <th className="table-heading-text align-center">
                                    {formatFor === 'investment_declaration' ? 'Declaration Summary' : 'Proof Summary'}
                                </th>
                                <th className="table-heading-text align-center">Tax Regime</th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Remarks</th>
                                <th className="table-heading-text text-end">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <Loader container={true} />
                        ) : (
                            <tbody>
                                {InvestmentList.length > 0 ? (
                                    InvestmentList.map((i, index) => {
                                        const investment = i.investment_form;
                                        const versionField = formatFor === 'investment_declaration' ? 'declaration_approval_flow_version' : 'proof_approval_flow_version';

                                        return (
                                            <tr key={i.id} className="custom-table-head-td">
                                                <td className="table-body">{index + 1}</td>
                                                {version === 'all' && (
                                                    <td className="table-body align-center">
                                                        <span className={`version-badge ${investment[versionField] === formatData?.find(f => f.is_active)?.version ? 'version-current' : 'version-old'}`}>
                                                            v{investment[versionField]}
                                                        </span>
                                                    </td>
                                                )}
                                                <td className="table-body" style={{ textAlign: "center" }}>
                                                    <CustomImageModal customStyle>
                                                        {investment.emp_profilepic ? (
                                                            <img
                                                                src={`${IMAGE_URL}${investment.emp_profilepic}`}
                                                                alt="profile" className="profile-img"
                                                            />
                                                        ) : (
                                                            <UserDefaultLogo user={{ name: investment.emp_name, profilepic: investment.emp_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                        )}
                                                    </CustomImageModal>
                                                    <p className="mb-0">{investment.emp_code}-{investment.emp_name}</p>
                                                </td>
                                                <td className="table-body">
                                                    {formatFor === 'investment_declaration' ? (
                                                        <InvestmentDeclarationSummary form={investment} />
                                                    ) : (
                                                        <InvestmentProofSummary form={investment} />
                                                    )}
                                                </td>
                                                <td className="table-body align-center">
                                                    {investment.regime_details?.name}
                                                    ({formatDate(investment.regime_details?.financial_year_start, true).MonthYear}-{formatDate(investment.regime_details?.financial_year_end, true).MonthYear} )
                                                </td>
                                                {/* {getApprovalStatus(investment, formatFor)} */}
                                                {formatFor === 'investment_declaration' ? (
                                                    <>
                                                        <ViewDynamicApprovalStatus dynamic_approval={investment.declaration_dynamic_approval} />
                                                        <ViewDynamicApprovalRemarks dynamic_approval={investment.declaration_dynamic_approval} />
                                                    </>
                                                ) : (
                                                    <>
                                                        <ViewDynamicApprovalStatus dynamic_approval={investment.proof_dynamic_approval} />
                                                        <ViewDynamicApprovalRemarks dynamic_approval={investment.proof_dynamic_approval} />
                                                    </>
                                                )}
                                                <td className="table-body">
                                                    {formatFor === 'investment_declaration' ? (
                                                        getDeclarationApprovalComponent(i, formatFor)
                                                    ) : (
                                                        getProofApprovalComponent(i, formatFor)
                                                    )}

                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={version === 'all' ? 9 : 8} className="text-center table-body">
                                            No {formatFor === 'investment_declaration' ? 'declaration' : 'proof'} requests found for Stage {level} {version !== 'all' && `(Version ${version})`}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

const DynamicArrearApprovalTable = ({ level, version, formatData, getApprovalStages, formatFor }) => {
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(false);
    const [arrearList, setArrearList] = useState([]);
    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("company_id") || null}`
    );
    const approver = sessionStorage.getItem('emp_code')

    const getDynamicArrearRequestData = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(
                `${BASE_URL}/wfm/dynamicapproval-stagesdata-byversionedformat-withlegacy/${formatFor}/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/${approver}/${version}/`
            );
            setArrearList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        if (level !== 0) {
            getDynamicArrearRequestData();
        }
    }, [level, selectedStatus, version]);

    const getVersionDisplay = () => {
        if (version === 'all') {
            return 'All Versions';
        }
        const versionFormat = formatData?.find(format => format.version === version);
        return `Version ${version} ${versionFormat?.is_active ? '(Current)' : '(Old)'}`;
    };




    const canShowApprovalAction = ({ approvals, currentLevel, requestStatus }) => {
        if (!Array.isArray(approvals) || approvals.length === 0) return false;


        if (!["pending", "approved"].includes(requestStatus)) return false;

        const currentApproval = approvals.find(a => Number(a.level) === Number(currentLevel));
        const prevApproval = approvals.find(a => Number(a.level) === Number(currentLevel) - 1);
        const nextApproval = approvals.find(a => Number(a.level) === Number(currentLevel) + 1);

        if (!currentApproval) return false;

        if (currentLevel > 1 && prevApproval?.approval_status !== "approved") {
            return false;
        }

        const canProceed =
            currentApproval.approval_status === "pending" ||
            (currentApproval.approval_status === "approved" &&
                nextApproval?.approval_status === "pending");



        if (!canProceed) return false;

        if (nextApproval?.approval_status === "approved") return false;

        return true;
    };


    const getApprovalComponent = (i, formatFor) => {
        const approvals = i.arrear_details?.dynamic_approval || [];

        const canShow = canShowApprovalAction({
            approvals,
            currentLevel: level,
            requestStatus: i.approval_status
        });

        if (!canShow) {

            if (approvals.some(a => a.approval_status === "rejected")) {
                return "Request Closed";
            }

            if (approvals.every(a => a.approval_status === "approved")) {
                return "Fully Approved";
            }

            return "No Action Available";
        }

        const components = {
            arrear: (
                <ArrearDynamicApprovalActionModal
                    i={i}
                    approvalType={formatFor}
                    getDynamicRequestData={getDynamicArrearRequestData}
                    getApprovalStages={getApprovalStages}
                />
            )
        };

        return components[formatFor] || "No Action Available";
    };





    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick />
            <div className="attendance-history-cont">
                <div className="attendance-subcont">
                    <div className="field-cont">
                        {SUPER_ADMIN && <div title="Sub Companies" className="field-cont-div">
                            {buffer1 ? <div className="spinner-vsmall"></div> : <Office />}
                            <select
                                className="attendance-input-field width-10vw date-field"
                                value={selectedDivision}
                                onChange={(e) => setDivision(e.target.value)}
                                style={{ cursor: "pointer" }}
                            >
                                <option value="null">All Sub Companies</option>
                                {SUB_COMPANIES.map((i) => (
                                    <option key={i.id} value={i.id}>{i.title}</option>
                                ))}
                            </select>
                            <hr className="field-cont-hr" />
                        </div>}
                        <div title="All" className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw date-field"
                                value={selectedStatus}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectedStatus(value);
                                    if (value === "rejected") {
                                        setPreviousStatus("pending");
                                    } else if (value === "null") {
                                        setPreviousStatus("null");
                                    } else {
                                        setPreviousStatus("approved");
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <option value="null">All</option>
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                    </div>
                </div>

                <div className="table-css-white-background scroll-container-table">
                    <div className="table-heading-flex">
                        <div
                            className="repo-heading font-weight500 font-size-heading"
                            title={`Viewing: ${getVersionDisplay()} • Stage ${level} • ${formatFor === 'investment_declaration' ? 'Declaration' : 'Proof'} Approval`}
                            style={{ cursor: 'help' }}
                        >
                            Stage {level} of {formatFor === 'arrear' && 'Arrear'} - {getVersionDisplay()}
                        </div>
                    </div>

                    <table className="table-css">
                        <thead className="table-heading stciky-heading-top">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text text-lefttt">S. No.</th>
                                {version === 'all' && <th className="table-heading-text align-center">Version</th>}
                                <th className="table-heading-text align-center">Employee</th>
                                <th className="table-heading-text align-center">
                                    Arrear Summary
                                </th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Remarks</th>
                                <th className="table-heading-text text-end">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <Loader container={true} />
                        ) : (
                            <tbody>
                                {arrearList.length > 0 ? (
                                    arrearList.map((i, index) => {
                                        const arrear = i.arrear_details;
                                        const versionField = formatFor === 'approval_flow_version';

                                        return (
                                            <tr key={i.id} className="custom-table-head-td">
                                                <td className="table-body">{index + 1}</td>
                                                {version === 'all' && (
                                                    <td className="table-body align-center">
                                                        <span className={`version-badge ${arrear[versionField] === formatData?.find(f => f.is_active)?.version ? 'version-current' : 'version-old'}`}>
                                                            v{arrear[versionField]}
                                                        </span>
                                                    </td>
                                                )}
                                                <td className="table-body" style={{ textAlign: "center" }}>
                                                    <CustomImageModal customStyle>
                                                        {arrear.profilepic ? (
                                                            <img
                                                                src={`${IMAGE_URL}${arrear.profilepic}`}
                                                                alt="profile" className="profile-img"
                                                            />
                                                        ) : (
                                                            <UserDefaultLogo user={{ name: arrear.emp_name, profilepic: arrear.emp_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                        )}
                                                    </CustomImageModal>
                                                    <p className="mb-0">{arrear.emp_code}-{arrear.emp_name}</p>
                                                </td>
                                                <td className="table-body">

                                                    <ArrearSummary form={arrear} />

                                                </td>

                                                <ViewDynamicApprovalStatus dynamic_approval={i?.arrear_details?.dynamic_approval} />
                                                <ViewDynamicApprovalRemarks dynamic_approval={i?.arrear_details?.dynamic_approval} />
                                                <td className="table-body">
                                                    {getApprovalComponent(i, formatFor)}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={version === 'all' ? 9 : 8} className="text-center table-body">
                                            No arrear requests found for Stage {level} {version !== 'all' && `(Version ${version})`}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

const DynamicCompensatoryApprovalTable = ({ level, version, formatData, getApprovalStages, formatFor }) => {
    const { SUB_COMPANIES, SUPER_ADMIN, PORTAL_SETTINGS } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(false);
    const [compensatoryRequests, setCompensatoryRequests] = useState([]);
    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("company_id") || null}`
    );
    const approver = sessionStorage.getItem('emp_code')

    const getDynamicCompensatoryRequestData = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(
                `${BASE_URL}/wfm/dynamicapproval-stagesdata-byversionedformat-withlegacy/${formatFor}/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/${approver}/${version}/`
            );
            setCompensatoryRequests(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        if (level !== 0) {
            getDynamicCompensatoryRequestData();
        }
    }, [level, selectedStatus, version]);

    const getVersionDisplay = () => {
        if (version === 'all') {
            return 'All Versions';
        }
        const versionFormat = formatData?.find(format => format.version === version);
        return `Version ${version} ${versionFormat?.is_active ? '(Current)' : '(Old)'}`;
    };




    const canShowApprovalAction = ({ approvals, currentLevel, requestStatus }) => {
        if (!Array.isArray(approvals) || approvals.length === 0) return false;


        if (!["pending", "approved"].includes(requestStatus)) return false;

        const currentApproval = approvals.find(a => Number(a.level) === Number(currentLevel));
        const prevApproval = approvals.find(a => Number(a.level) === Number(currentLevel) - 1);
        const nextApproval = approvals.find(a => Number(a.level) === Number(currentLevel) + 1);

        if (!currentApproval) return false;

        if (currentLevel > 1 && prevApproval?.approval_status !== "approved") {
            return false;
        }

        const canProceed =
            currentApproval.approval_status === "pending" ||
            (currentApproval.approval_status === "approved" &&
                nextApproval?.approval_status === "pending");



        if (!canProceed) return false;

        if (nextApproval?.approval_status === "approved") return false;

        return true;
    };


    const getApprovalComponent = (i, formatFor) => {
        const approvals = i.compensatory_request?.dynamic_approval || [];

        const canShow = canShowApprovalAction({
            approvals,
            currentLevel: level,
            requestStatus: i.approval_status
        });

        if (!canShow) {

            if (approvals.some(a => a.approval_status === "rejected")) {
                return "Request Closed";
            }

            if (approvals.every(a => a.approval_status === "approved")) {
                return "Fully Approved";
            }

            return "No Action Available";
        }

        const components = {
            compensatory: (
                <CompensatoryDynamicApprovalActionModal
                    i={i}
                    approvalType={formatFor}
                    getDynamicRequestData={getDynamicCompensatoryRequestData}
                    getApprovalStages={getApprovalStages}
                />
            )
        };

        return components[formatFor] || "No Action Available";
    };




    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick />
            <div className="attendance-history-cont">
                <div className="attendance-subcont">
                    <div className="field-cont">
                        {SUPER_ADMIN && <div title="Sub Companies" className="field-cont-div">
                            {buffer1 ? <div className="spinner-vsmall"></div> : <Office />}
                            <select
                                className="attendance-input-field width-10vw date-field"
                                value={selectedDivision}
                                onChange={(e) => setDivision(e.target.value)}
                                style={{ cursor: "pointer" }}
                            >
                                <option value="null">All Sub Companies</option>
                                {SUB_COMPANIES.map((i) => (
                                    <option key={i.id} value={i.id}>{i.title}</option>
                                ))}
                            </select>
                            <hr className="field-cont-hr" />
                        </div>}
                        <div title="All" className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw date-field"
                                value={selectedStatus}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectedStatus(value);
                                    if (value === "rejected") {
                                        setPreviousStatus("pending");
                                    } else if (value === "null") {
                                        setPreviousStatus("null");
                                    } else {
                                        setPreviousStatus("approved");
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <option value="null">All</option>
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                    </div>
                </div>

                <div className="table-css-white-background scroll-container-table">
                    <div className="table-heading-flex">
                        <div
                            className="repo-heading font-weight500 font-size-heading"
                            title={`Viewing: ${getVersionDisplay()} • Stage ${level} • ${formatFor === 'investment_declaration' ? 'Declaration' : 'Proof'} Approval`}
                            style={{ cursor: 'help' }}
                        >
                            Stage {level} of Compensatory Leave - {getVersionDisplay()}
                        </div>
                    </div>

                    <table className="table-css">
                        <thead className="table-heading stciky-heading-top">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text text-lefttt">S. No.</th>
                                {version === 'all' && <th className="table-heading-text align-center">Version</th>}
                                <th className="table-heading-text align-center">Employee</th>
                                <th className="table-heading-text align-center">
                                    Comp. Leave Summary
                                </th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Remarks</th>
                                <th className="table-heading-text text-end">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <Loader container={true} />
                        ) : (
                            <tbody>
                                {compensatoryRequests.length > 0 ? (
                                    compensatoryRequests.map((i, index) => {
                                        const request_data = i.compensatory_request;
                                        const versionField = formatFor === 'approval_flow_version';

                                        const isShortLeave = (request_data?.leave_type || "").toLowerCase().replace(/\s+/g, '') === "shortleave" || (request_data?.duration || "").toLowerCase().replace(/\s+/g, '') === "shortleave" || (request_data?.leave_Duration || "").toLowerCase().replace(/\s+/g, '') === "shortleave";
                                        const isShortLeaveDisabled = PORTAL_SETTINGS?.eligible_for_shortleave_credit === false || String(PORTAL_SETTINGS?.eligible_for_shortleave_credit) === "false";

                                        return (
                                            version === 0 ?
                                                <tr key={i.id} className="custom-table-head-td">
                                                    <td className="table-body">{index + 1}</td>
                                                    {version === 'all' && (
                                                        <td className="table-body align-center">
                                                            <span className={`version-badge ${request_data[versionField] === formatData?.find(f => f.is_active)?.version ? 'version-current' : 'version-old'}`}>
                                                                v{request_data[versionField]}
                                                            </span>
                                                        </td>
                                                    )}
                                                    <td className="table-body" style={{ textAlign: "center" }}>
                                                        <CustomImageModal customStyle>
                                                            {request_data.profilepic ? (
                                                                <img
                                                                    src={`${IMAGE_URL}${request_data.profilepic}`}
                                                                    alt="profile" className="profile-img"
                                                                />
                                                            ) : (
                                                                <UserDefaultLogo user={{ name: request_data.name, profilepic: request_data.emp_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                            )}
                                                        </CustomImageModal>
                                                        <p className="mb-0">{request_data.empcode}-{request_data.name}</p>
                                                    </td>
                                                    <td className="table-body">

                                                        <CompensatoryLeaveSummary form={request_data} />

                                                    </td>


                                                    <td title="Status" className="table-body">

                                                        <div request-status={i.compensatory_request.rh_leave_status} className="request-status" key={index}>
                                                            {i.compensatory_request.rh_leave_status === "pending"
                                                                ? "Pending For Rh Approval ⌛"
                                                                : i.compensatory_request.rh_leave_status === "rejected"
                                                                    ? "Rh Rejected ✖, "
                                                                    : "Rh Approved ✔, "}
                                                        </div>

                                                    </td>

                                                    <td
                                                        className="request-status align-center"

                                                    >
                                                        {(i.compensatory_request.rh_leave_status === "rejected"
                                                            ?
                                                            i.compensatory_request.reason
                                                            :
                                                            '-')}
                                                    </td>
                                                    {/* <td className="table-body">
                                                        <td className="align-center">
                                                            {i?.compensatory_request?.rh_leave_status === "pending" ? (
                                                                <div className="flex-row align-center width-5vw">
                                                                    <CompoffShortLeaveApproved
                                                                        i={i}
                                                                        getCompensatoryList={getDynamicCompensatoryRequestData}
                                                                    />
                                                                    <CompoffShortLeaveReject
                                                                        i={i}
                                                                        getCompensatoryList={getDynamicCompensatoryRequestData}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                i?.compensatory_request?.rh_leave_status === "rejected" ?
                                                                    <div className="flex-row align-center width-5vw">
                                                                        <CompoffShortLeaveApproved
                                                                            i={i}
                                                                            getCompensatoryList={getDynamicCompensatoryRequestData}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    <div request-status={i.compensatory_request.rh_leave_status} className="request-status align-center text-uppercase" >
                                                                        {i.compensatory_request.rh_leave_status}
                                                                    </div>

                                                            )}
                                                        </td>
                                                    </td> */}
                                                    <td className="table-body">
                                                        <td className="align-center">
                                                            {i?.compensatory_request?.rh_leave_status === "pending" ? (
                                                                <div className="flex-row align-center width-5vw">
                                                                    <CompoffShortLeaveApproved
                                                                        i={i}
                                                                        getCompensatoryList={getDynamicCompensatoryRequestData}
                                                                    />
                                                                    <CompoffShortLeaveReject
                                                                        i={i}
                                                                        getCompensatoryList={getDynamicCompensatoryRequestData}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                i?.compensatory_request?.rh_leave_status === "rejected" ? (
                                                                    <div className="flex-row align-center width-5vw">
                                                                        {isShortLeave && isShortLeaveDisabled ? (
                                                                            <span className="request-status" request-status="rejected" style={{ whiteSpace: "nowrap", marginRight: "8px" }}>
                                                                                Policy Discontinued
                                                                            </span>
                                                                        ) : (
                                                                            <CompoffShortLeaveApproved
                                                                                i={i}
                                                                                getCompensatoryList={getDynamicCompensatoryRequestData}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <div request-status={i.compensatory_request.rh_leave_status} className="request-status align-center text-uppercase" >
                                                                        {i.compensatory_request.rh_leave_status}
                                                                    </div>
                                                                )
                                                            )}
                                                        </td>
                                                    </td>
                                                </tr>
                                                :
                                                <tr key={i.id} className="custom-table-head-td">
                                                    <td className="table-body">{index + 1}</td>
                                                    {version === 'all' && (
                                                        <td className="table-body align-center">
                                                            <span className={`version-badge ${request_data[versionField] === formatData?.find(f => f.is_active)?.version ? 'version-current' : 'version-old'}`}>
                                                                v{request_data[versionField]}
                                                            </span>
                                                        </td>
                                                    )}
                                                    <td className="table-body" style={{ textAlign: "center" }}>
                                                        <CustomImageModal customStyle>
                                                            {request_data.profilepic ? (
                                                                <img
                                                                    src={`${IMAGE_URL}${request_data.profilepic}`}
                                                                    alt="profile" className="profile-img"
                                                                />
                                                            ) : (
                                                                <UserDefaultLogo user={{ name: request_data.name, profilepic: request_data.emp_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                            )}
                                                        </CustomImageModal>
                                                        <p className="mb-0">{request_data.empcode}-{request_data.name}</p>
                                                    </td>
                                                    <td className="table-body">
                                                        <CompensatoryLeaveSummary form={request_data} />

                                                    </td>

                                                    <ViewDynamicApprovalStatus dynamic_approval={i?.compensatory_request?.dynamic_approval} />
                                                    <ViewDynamicApprovalRemarks dynamic_approval={i?.compensatory_request?.dynamic_approval} />
                                                    <td className="table-body">
                                                        {getApprovalComponent(i, formatFor)}
                                                    </td>
                                                </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={version === 'all' ? 9 : 8} className="text-center table-body">
                                            No Compensatory requests found for Stage {level} {version !== 'all' && `(Version ${version})`}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

export {
    // DynamicLeaveApprovalTable,
    // DynamicOutdutyApprovalTable,
    // DynamicCompOffApprovalTable,
    DynamicImprestApprovalTable,
    DynamicsExpenseApproveTable,
    // DynamicAdvanceApprovalTable,
    // DynamicSeprationApprovalTable,
    // DynamicEmpDetailsChangeApprovalTable,
    // DynamicBankApprovalTable,
    DynamicBankDetailsChangeApprovalTable,

    DynamicInvestmentApprovalTable,
    DynamicArrearApprovalTable,
    DynamicCompensatoryApprovalTable,
}